import disputeWorkflow from "@/tool/photographyDisputes.cjs";
import request from "@/tool/request";
import API from "@/tool/api";
import { unwrapResult, getResultMessage } from "@/tool/result";
import qs from "qs";

export default (options = {}) => disputeWorkflow.createDisputeWorkflow({
    ...options,
    errorMessage: getResultMessage,
    transport: {
        async options(serviceOrderNo) {
            return unwrapResult(await request.get(API.photography.serviceAfterSalesOptions(serviceOrderNo), { headers: { "Cache-Control": "no-store" } }), "售后资格读取失败");
        },
        async create(serviceOrderNo, mode, description, key, payload) {
            if (mode === "AFTER_SALES" && options.participant === "CREATOR") throw new Error("仅预约用户可发起售后");
            const endpoint = mode === "CREATOR_NO_SHOW" ? API.photography.creatorNoShow(serviceOrderNo)
                : mode === "USER_NO_SHOW" ? API.photography.creatorUserNoShow(serviceOrderNo)
                    : mode === "AFTER_SALES" ? API.photography.serviceAfterSales(serviceOrderNo)
                        : mode === "UNSELECTED_REFUND" ? API.photography.unselectedRefund(serviceOrderNo) : API.photography.serviceOtherIssue(serviceOrderNo);
            return unwrapResult(await request.post(endpoint, mode === "AFTER_SALES" ? payload : { description }, {
                headers: { "Content-Type": "application/json", "Idempotency-Key": key },
            }), "异常提交失败");
        },
        async upload(disputeNo, file, evidenceRound) {
            const body = new FormData();
            body.append("file", file);
            return unwrapResult(await request.post(API.photography.disputeEvidence(disputeNo), body, {headers:{"Evidence-Round":evidenceRound || 1}}), "证据上传失败");
        },
        async read(disputeNo) {
            return unwrapResult(await request.get(API.photography.appointmentDispute(disputeNo), {
                headers: { "Cache-Control": "no-store" },
            }), "处理记录加载失败");
        },
        async listEvidence(disputeNo) {
            return unwrapResult(await request.get(API.photography.disputeEvidence(disputeNo), {
                headers: { "Cache-Control": "no-store" },
            }), "证据列表加载失败");
        },
        async complete(disputeNo, key, evidenceRound) {
            return unwrapResult(await request.post(API.photography.completeDisputeEvidence(disputeNo), null, {
                headers: { "Idempotency-Key": key, "Evidence-Round": evidenceRound || 1 },
            }), "补证完成确认失败");
        },
        async convert(disputeNo, payload, key) {
            return unwrapResult(await request.post(API.photography.disputeRefundRequest(disputeNo), payload, {
                headers: { "Content-Type": "application/json", "Idempotency-Key": key },
            }), "退款诉求提交失败");
        },
        async withdraw(disputeNo) {
            return unwrapResult(await request.post(API.photography.withdrawDispute(disputeNo), null), "异常撤回失败");
        },
        async statement(disputeNo, statement, key) {
            return unwrapResult(await request.post(API.photography.disputeStatements(disputeNo), qs.stringify({ statement }), {
                headers: { "Idempotency-Key": key },
            }), "陈述提交失败");
        },
        async access(disputeNo, evidenceId) {
            const access = unwrapResult(await request.get(API.photography.disputeEvidenceAccess(disputeNo, evidenceId), {
                headers: { "Cache-Control": "no-store" },
            }), "证据读取失败");
            if (!access || typeof access.url !== "string" || !/^https:\/\/[^\s@]+$/i.test(access.url)) throw new Error("证据读取地址无效，请重新获取");
            return access;
        },
        async accessArrival(serviceOrderNo, arrivalId) {
            const access = unwrapResult(await request.post(API.photography.creatorArrivalPhotoAccess(serviceOrderNo, arrivalId), null, {
                headers: { "Cache-Control": "no-store" },
            }), "到场照片读取失败");
            if (!access || typeof access.url !== "string" || !/^https:\/\/[^\s@]+$/i.test(access.url)) throw new Error("到场照片读取地址无效，请重新获取");
            return access;
        },
    },
});
